import React from 'react';
import { Routes, Route } from "react-router-dom";

//Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";

//routes
import { authProtectedRoutes, publicRoutes, cartProtectedRoutes } from "./allRoutes";
import { AuthProtected, RoleProtected } from './AuthProtected';
import { CartProtected } from './CartProtected';
import SNEditProduct from '../SNPages/Products/EditProduct';

const Index = () => {
    return (
        <React.Fragment>
            <Routes>
                <Route>
                    {publicRoutes.map((route, idx) => (
                        <Route
                            path={route.path}
                            element={
                                <NonAuthLayout>
                                    {route.component}
                                </NonAuthLayout>
                            }
                            key={idx}
                            exact={true}
                        />
                    ))}
                </Route>

                <Route>
                    {authProtectedRoutes.map((route, idx) => (
                        <Route
                            path={route.path}
                            element={
                                <AuthProtected>
                                    <VerticalLayout>{route.component}</VerticalLayout>
                                </AuthProtected>}
                            key={idx}
                            exact={true}
                        />
                    ))}
                </Route>

                <Route>
                    {cartProtectedRoutes.map((route, idx) => (
                        <Route
                            path={route.path}
                            element={
                                <AuthProtected>
                                    <CartProtected>
                                        <VerticalLayout>{route.component}</VerticalLayout>
                                    </CartProtected>
                                </AuthProtected>}
                            key={idx}
                            exact={true}
                        />
                    ))}
                </Route>

                {/* Role-protected routes */}
                <Route path="/edit-product" element={
                    <AuthProtected>
                        <RoleProtected allowedRoles={['employee3']}>
                            <VerticalLayout>
                                <SNEditProduct />
                            </VerticalLayout>
                        </RoleProtected>
                    </AuthProtected>
                } />
            </Routes>
        </React.Fragment>
    );
};

export default Index;